@if (isMatMenu) {
  <button mat-menu-item
          data-test="dms-downloadFolder-button"
          [ngClass]="btnClass"
          [matTooltip]="title"
          [matTooltipDisabled]="isMatMenu"
          (click)="downloadFolder()">
    <i [hidden]="labelOnly" class="icon fa-fw fas fa-download"></i>
    <span [hidden]="iconOnly" class="mb-0">{{ title }}</span>
  </button>
} @else {
  <sk-button [appearance]="iconOnly ? 'icon' : 'text'"
             data-test="dms-downloadFolder-button"
             [color]="iconOnly ? 'unspecified' : 'primary'"
             [label]="!iconOnly ? title : ''"
             [ngClass]="btnClass"
             [matTooltip]="title"
             [matTooltipDisabled]="isMatMenu"
             (click)="downloadFolder()">
    @if (iconOnly) {
      <i [hidden]="labelOnly" class="icon fa-fw fas fa-download"></i>
    } @else {
      <ng-template buttonPrefix>
        <i [hidden]="labelOnly" class="icon fa-fw fas fa-download"></i>
      </ng-template>
    }
  </sk-button>
}
